import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CatSleepIcon from './Icons/Cat/CatSleep.icon';

export interface NoResultProps {
  icon?: React.ReactNode;
}

const StyledNoResultTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
`;
export const StyledNoResult = styled.div`
  width: 100%;
  height: 100%;
  min-height: 300px;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const NoResultComponent = ({ icon }: NoResultProps) => {
  const { t } = useTranslation();
  return (
    <StyledNoResult>
      {icon ? icon : <CatSleepIcon />}
      <StyledNoResultTitle>{t('No result')}</StyledNoResultTitle>
    </StyledNoResult>
  );
};

export default NoResultComponent;
